import { createDefaultLoadable, IPermission, Loadable } from "../../models"

export interface IRoleLookup {
    id: string,
    name: string,
    permissions: IPermission[], 
    isSelected: boolean
};

export interface RoleLookupState extends Loadable {
    roles: IRoleLookup[];
    copilotRoles: IRoleLookup[];
    copilotRolesLoading: boolean;
    copilotRolesError: Error | null;
}

export function createDefaultRoleLookupState(): RoleLookupState {
    return {
        ...createDefaultLoadable(),
        roles: [],
        copilotRoles: [],
        copilotRolesLoading: false,
        copilotRolesError: null,
    };
}

export const initialRoleLookupState: RoleLookupState = {
    ...createDefaultRoleLookupState()
}
